import React, { Component } from 'react';
import Header from '~/components/header/header';
import SideNav from '~/components/sideNav/sideNav';
import ErrorBoundary from '~/components/errorBoundary/errorBoundary';
import styles from './page.css';

export default class Page extends Component {
  state = {
    sideNavOpen: false
  };

  toggleSideNavOpen = () => {
    this.setState({
      sideNavOpen: !this.state.sideNavOpen
    });
  };

  render() {
    const { hideSideNav } = this.props;
    return (
      <div>
        <Header hideBurger={hideSideNav} onBurgerClick={this.toggleSideNavOpen} />
        <section className={`flex ${styles.container}`}>
          {!hideSideNav && <SideNav onClose={this.toggleSideNavOpen} isOpen={this.state.sideNavOpen} />}
          <ErrorBoundary>
            <div className={`relative flex-grow-1 ${styles.mainContent}`}>
              <div className="ma3 ma3-m ma4-l">{this.props.children}</div>
            </div>
          </ErrorBoundary>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/page/page.jsx